import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

function HR_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries: Unblocking the Way to Clarity
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <HR_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <HR_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function HR_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <div className={classes.root}>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What qualifications do I need to start a career in HR?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Typically, entry-level HR positions require a bachelor’s degree in
            Human Resources, Business Administration, Psychology, or a related
            field. Certifications such as SHRM-CP (Society for Human Resource
            Management-Certified Professional) or PHR (Professional in Human
            Resources) can enhance job prospects.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What skills are important for an HR professional?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Key skills include strong communication abilities, organizational
            and time-management skills, conflict resolution, problem-solving,
            confidentiality, and proficiency with HR software. Understanding
            employment law, recruitment techniques, and employee development are
            also important.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What are the primary functions of an HR department?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            HR departments manage recruiting and hiring, employee relations,
            compensation and benefits, performance management, training and
            development, compliance with labor laws, and maintaining workplace
            safety.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel4'}
        onChange={handleChange('panel4')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            How does HR support employee development?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            HR plays a crucial role in employee development by offering training
            programs, facilitating career development initiatives, performance
            management systems, and mentorship programs. HR helps ensure that
            employees have opportunities to grow within the company.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        className="py-2"
        expanded={expanded === 'panel5'}
        onChange={handleChange('panel5')}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
          className="FAQ_background_color"
        >
          <Typography style={{ fontSize: '1.2rem' }}>
            What is the role of HR in handling workplace conflicts?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            HR acts as a mediator in conflicts, ensuring that both employees and
            management can express concerns fairly. They ensure compliance with
            workplace policies and laws while aiming to resolve issues through
            dialogue, investigations, and disciplinary actions if necessary.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default HR_FAQ_page
